module.exports = __webpack_public_path__ + "media/images/generator1-b01e5ca3782dc684b11041dc7759427b.jpg";